import { Injectable, inject } from '@angular/core';
import { filter, map, take } from 'rxjs/operators';

import {
  CanActivateAsync,
  CanActivateChildAsync,
} from '@plugins/client/routing/types';

import { TranslationStatusService } from '../services/translation-status.service';

@Injectable({
  providedIn: 'root',
})
export class TranslationGuard
  implements CanActivateAsync, CanActivateChildAsync
{
  private translationStatusService = inject(TranslationStatusService);

  canActivate() {
    return this.validate();
  }

  canActivateChild() {
    return this.validate();
  }

  private validate() {
    return this.translationStatusService.loading$.pipe(
      filter((loading) => !loading),
      map(() => true),
      take(1),
    );
  }
}
